/**
 * Arquivo para gerenciar diversos templates, baseado em regras especificas. 
 * Deve ser exportado a chave `App`, que será utilizada pelo Vue.js na criação da página em main.js 
 */

import MainApp from '@templates/App/App.vue'
import EmptyApp from '@templates/EmptyApp/EmptyApp.vue'
import OnlyFooter from '@templates/OnlyFooter/OnlyFooter.vue'

let App = null

if (window.location.pathname.indexOf('pos-conteudo-gratuito') > -1)
	App = OnlyFooter
else if (window.location.pathname.indexOf('prouni') > -1)
	App = EmptyApp
else
    App = MainApp

export {
	App
}

